import React from 'react';
import SplashScreen from '../Componentsplahscreen/SplashScreen';


function Splash() {

  return (
    <div>
     <SplashScreen/>
    </div>
  );
}

export default Splash;